import { render, staticRenderFns } from "./VendorPartStatusStatistics.vue?vue&type=template&id=1391668f&scoped=true&"
import script from "./VendorPartStatusStatistics.vue?vue&type=script&lang=ts&"
export * from "./VendorPartStatusStatistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1391668f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
